<section class="mx-3">
    <div class="d-flex align-items-center">
        <div>
            <button mat-icon-button class="back_icon me-2" (click)="backnavigation()">
                <i class="fa-solid fa-arrow-left"></i>
            </button>
        </div>
        <div>
            <h4 class="m-0"><span translate class="me-1">My Leaves </span>- {{requesttype | removeUnderscore}}</h4>
        </div>
    </div>
    <div class="table-container mt-2">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

            <ng-container *ngIf="requesttype != 'REJECTED' || requesttype != 'CANCELLATION'" matColumnDef="actions">
                <th translate mat-header-cell *matHeaderCellDef> actions </th>
                <td mat-cell *matCellDef="let row">
                    <div class="action_button" [matMenuTriggerFor]="actionrequest" aria-label="Actions">
                        <i class="fa-solid fa-ellipsis-vertical"></i>
                    </div>
                    <mat-menu #actionrequest="matMenu">
                        <button *ngIf="requesttype == 'APPROVED'" mat-menu-item class="cancel_button"
                            (click)="actionrequestapi('LEAVE_CANCELLATION_REQUEST', row?.id)">
                            <span translate>Leave Cancellation Request</span>
                        </button>
                        <button *ngIf="requesttype == 'PENDING'" mat-menu-item class="cancel_button"
                            (click)="actionrequestapi('CANCELLED', row?.id)">
                            <span translate>Cancel</span>
                        </button>
                    </mat-menu>
                </td>
            </ng-container>

            <ng-container matColumnDef="start_date">
                <th translate mat-header-cell *matHeaderCellDef> From </th>
                <td mat-cell *matCellDef="let element"> {{element.start_date}} </td>
            </ng-container>

            <ng-container matColumnDef="end_date">
                <th translate mat-header-cell *matHeaderCellDef> To </th>
                <td mat-cell *matCellDef="let element"> {{element.end_date}} </td>
            </ng-container>

            <ng-container matColumnDef="leave_type">
                <th translate mat-header-cell *matHeaderCellDef> Leave Type </th>
                <td mat-cell *matCellDef="let element"> {{element.leave_name}} </td>
            </ng-container>

            <ng-container matColumnDef="reason">
                <th translate mat-header-cell *matHeaderCellDef> Reason</th>
                <td mat-cell *matCellDef="let element"> {{element.reason}} </td>
            </ng-container>

            <ng-container matColumnDef="duration">
                <th translate mat-header-cell *matHeaderCellDef> Duration </th>
                <td mat-cell *matCellDef="let element"> {{element.duration}} </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th translate mat-header-cell *matHeaderCellDef> Status</th>
                <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="element.status === 'PENDING'; else APPROVED">
                        <span style="color: #6D6F02;">{{element.status}}</span>
                    </ng-container>
                    <ng-template #APPROVED>
                        <span style="color: #55AB58;">{{element.status}}</span>
                    </ng-template>
                </td>
            </ng-container>

            <!-- <ng-container matColumnDef="actions" sticky>
            <th mat-header-cell *matHeaderCellDef> Actions</th>
            <td mat-cell *matCellDef="let element"> 
                <div>
                  <div class="action_button" [matMenuTriggerFor]="actionrequest" aria-label="Actions">
                        <i class="fa-solid fa-ellipsis-vertical"></i>
                    </div>
                    <mat-menu #actionrequest="matMenu">
                        <button mat-menu-item (click)="actionrequestapi('APPROVED', element)">
                          <span>Approved</span>
                        </button>
                        <button mat-menu-item (click)="actionrequestapi('REJECTED', element)">
                          <span>Rejected</span>
                        </button>
                      </mat-menu>
                </div> 
            </td>
        </ng-container> -->

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)">
            </tr>
            <tr class="mat-row" *matNoDataRow>
                <td translate class="mat-cell" colspan="4">No data</td>
            </tr>
        </table>
    </div>
</section>